import { createEntityByIdSource, type EntityByIdStorage } from 'serviceWorker/channelServers/entitySource';
import type { EntityByIdSource } from 'serviceWorker/channelServers/serveEntityRequests';
import * as dbInspectionsService from 'serviceWorker/db/inspections/inspectionsService';
import type { InspectionModel } from 'shared/domain/inspection/inspectionModel';
import { inspectionContract } from 'shared/domain/inspection/inspectionContract';
import { canSyncInspections, inspectionsSync } from './index';
import { readInspectionModels, readStoredInspection } from './inspectionReads';

export const inspectionStorage: EntityByIdStorage<InspectionModel> = {
  service: dbInspectionsService,
  contract: inspectionContract,
  ...inspectionsSync,
  readAll: readInspectionModels,
  readOne: readStoredInspection,
};

const storedInspections = createEntityByIdSource(inspectionStorage);

/**
 * Inspections of the selected project. Standard users have no access to
 * inspections and nothing is ever downloaded for them: their reads are
 * answered at once instead of waiting for a download that never comes.
 */
export const inspectionSource: EntityByIdSource<InspectionModel> = {
  getAll: async () => ((await canSyncInspections()) ? storedInspections.getAll() : []),

  getOneById: async (id) => {
    if (!(await canSyncInspections())) {
      throw new Error('Inspections are not available for this role');
    }
    return storedInspections.getOneById(id);
  },

  sync: () => storedInspections.sync(),
};
